import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ResourceData } from '@app/shared/abstract/resource.data';
import { EventPlannerModel, EventPlannerSectionModel } from './event-planner.model';

@Injectable({
  providedIn: 'root',
})
export class EventPlannerService {
  private readonly apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getPlanner(eventId: number | string): Observable<ResourceData<EventPlannerModel>> {
    return this.http.get<ResourceData<EventPlannerModel>>(`${this.apiUrl}/api/events/${eventId}/planner`);
  }

  updatePlanner(eventId: number | string, sections: EventPlannerSectionModel[]): Observable<{ message: string; data: EventPlannerModel }> {
    return this.http.put<{ message: string; data: EventPlannerModel }>(`${this.apiUrl}/api/events/${eventId}/planner`, {
      sections,
    });
  }
}

